// extracted by mini-css-extract-plugin
export default {"collapsibleBox":"App-module_collapsibleBox_e6a846","employeeSectionPadding":"App-module_employeeSectionPadding_ded0a2","basketContainer":"App-module_basketContainer_dff83e"};